import styled from 'styled-components'

import { Title5 } from 'components/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled(Title5)`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 16px;
  margin-bottom: 2px;

  ${({ theme, small }) =>
    small &&
    `
      font-size: 12px;
      color: ${theme.colors.blue};
      font-family: ${theme.fonts.semiBold};
      margin: 0;
    `};
`
